import { Meta, Title } from "@solidjs/meta";
import { Show } from "solid-js";
import { ClosingCTA } from "~/components/marketing/ClosingCTA";
import { SHOW_SOCIAL_PROOF } from "~/components/marketing/content";
import { TestimonialsSection, TrustSection } from "~/components/marketing/TrustSections";
import { PageHero } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";
import { DayStrip } from "./internal/DayStrip";
import {
  AutopilotSection,
  FollowUpSection,
  OffersSection,
  RoundTripSection,
  TogetherSection,
} from "./internal/Sections";

/** The executives' page: everything that happens around a meeting without anyone chasing it. */
export const ExecutivesPage = () => {
  const { t } = useI18n();
  return (
    <>
      <Title>{t("marketing.executives.meta_title")}</Title>
      <Meta name="description" content={t("marketing.executives.hero.sub")} />
      <PageHero
        eyebrow={t("marketing.nav.for_executives")}
        title={t("marketing.executives.hero.title")}
        sub={t("marketing.executives.hero.sub")}
        from="executives hero"
      >
        <div class="mx-auto max-w-5xl">
          <DayStrip />
        </div>
      </PageHero>
      <RoundTripSection />
      <FollowUpSection />
      <AutopilotSection />
      <OffersSection />
      <TogetherSection />
      <TrustSection />
      <Show when={SHOW_SOCIAL_PROOF}>
        <TestimonialsSection />
      </Show>
      <ClosingCTA id="execs-closing" title={t("marketing.executives.closing")} from="executives closing" />
    </>
  );
};
